import React from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { FileSelection } from '../../containers/Files'
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent'
import { connect, compose } from "react-redux";
import { fetch, update, updateEquipment, createEquipment } from "../../store/actions/brand";
import {  updateUser } from "../../store/actions/auth"
import { hideLoader } from "../../store/actions/loader";
import { URL_PATTERN, MESSAGES } from './../../constants.js'
import { AlertJsMessage, tzStrings } from './../../helpers.js'
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


const styles = theme => ({
  root: {
      "& .MuiInputBase-input": {
        height: "160px !important",
      },
    },
  textarea: {
    height: "190px !important"
  }
});

class BrandProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand: {
        displayName: '',
        imgUrl: '',
        fileId: 0,
        profileImgUrl: '',
        profileFileId: 0,
        goals: '',
        story: '',
        logoImgUrl: '',
        logoFileId: 0,
        referralFileId: 0,
        isActionPlanTab: true,
        referralContent: ''
      },
      equipment: {},
      timeZoneId: 0
    }
  }

  componentDidMount() {
    this.props.fetch();
  }

  static getDerivedStateFromProps(props, state) {
    let updateState = {};
    const { brand, equipment, currentUser } = props;
    if (state.brand._id) {
      updateState['brand'] = { ...state.brand };
    } else if (Object.keys(brand).length) {
      updateState['brand'] = { ...props.brand };
    }

    if (Object.keys(state.equipment).length) {
      updateState['equipment'] = { ...state.equipment };
    } else if (Object.keys(equipment).length) {
      updateState['equipment'] = { ...props.equipment };
    }

    if (state.timeZoneId) {
      updateState['timeZoneId'] = state.timeZoneId
    } else {
      if(currentUser && currentUser.user) {
        const user = currentUser.user;
        updateState['timeZoneId'] = user.timeZoneId
      }
    }
    
    return updateState;
  }

  handleChange = (field, type = 'brand') => event => {
    let updateState = {
      ...this.state[type],
      [field]: event.target.value
    };
    this.setState({
      ...this.state,
      [type]: { ...updateState }
    });
  }

  

  handleTimeZoneChange = field => event => {
    this.setState({
      ...this.state,
      [field]: event.target.value
    })
  }

  submitMainData() {
    const { type, selectedFile, previewImageSrc } = this.mainFile.state;
    if (type === 'library') {
      if (selectedFile) {
        const data = {
          displayName: this.state.brand.displayName,
          imgUrl: selectedFile.url,
          fileId: selectedFile._id,
          assignUpdate: 'mainPage'
        };
        this.submitForm(data);
      } else {
        AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
        return;
      }
    } else {
      this.setState({
        isValidating: true
      }, () => {
        if (previewImageSrc) {
          this.mainFile.submitNewFile().then((file) => {
            const data = {
              displayName: this.state.brand.displayName,
              imgUrl: file.url,
              fileId: file._id,
              assignUpdate: 'mainPage'
            };
            this.submitForm(data);
          })
        } else {
          AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
          return;
        }
      })
    }
  }

  submitTimeZoneData() {
    const { timeZoneId } = this.state;
    if (timeZoneId === 0) {
      AlertJsMessage('Please select Timezone.');
      return;
    }
    const data = {
      timeZoneId: this.state.timeZoneId,
    };
    this.updateUserInfo(data);
  }
  

  submitProfileData() {
    let data = {
      goals: this.state.brand.goals,
      story: this.state.brand.story,
    };
    this.submitForm(data);
  };

  
  submitProfileCoverData = () => {
    const { type, selectedFile, previewImageSrc } = this.profileFile.state;
    if (type === 'library') {
      if (selectedFile) {
        let data = {
          profileImgUrl: selectedFile.url,
          profileFileId: selectedFile._id,
          assignUpdate: 'profilePhoto'
        };
        this.submitForm(data);
      } else {
        AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
        return;
      }
    } else {
      this.setState({
        isValidating: true
      }, () => {
        if (previewImageSrc) {
          this.profileFile.submitNewFile().then((file) => {
            let data = {
              profileImgUrl: file.url,
              profileFileId: file._id,
              assignUpdate: 'profilePhoto'
            };
            this.submitForm(data);
          })
        } else {
          AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
          return;
        }
      })
    }
  }

  submitLogoData = () => {
    const { type, selectedFile, fileLoaded, isDelete, previewImageSrc } = this.logoFile.state;
    
    if(isDelete && !fileLoaded) {
      let data = {
        isDeleteLogo: true
      };
      this.submitForm(data);
    } else {
      if (type === 'library') {
        if (selectedFile) {
          let data = {
            logoImgUrl: selectedFile.url,
            logoFileId: selectedFile._id,
            assignUpdate: 'logo'
          };
          this.submitForm(data);
        } else {
          AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
          return;
        }
      } else {
        this.setState({
          isValidating: true
        }, () => {
          if (previewImageSrc) {
            this.logoFile.submitNewFile().then((file) => {
              let data = {
                logoImgUrl: file.url,
                logoFileId: file._id,
                assignUpdate: 'logo'
              };
              this.submitForm(data);
            })
          } else {
            AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
            return;
          }
        })
      }
    }
  }

  submitProductData() {
    const { type, selectedFile, previewImageSrc } = this.productFile.state;
    if (type === 'library') {
      if (selectedFile) {
        const data = {
          name: this.state.equipment.name,
          imgUrl: selectedFile.url,
          fileId: selectedFile._id,
          brandId: this.props.brand._id,
          assignUpdate: 'product'
        };
        this.submitForm(data, true);
      } else {
        AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
        return;
      }
    } else {
      this.setState({
        isValidating: true
      }, () => {
        if (previewImageSrc) {
          this.productFile.submitNewFile().then((file) => {
            const data = {
              name: this.state.equipment.name,
              imgUrl: file.url,
              fileId: file._id,
              brandId: this.props.brand._id,
              assignUpdate: 'product'
            };
            this.submitForm(data, true);
          })
        } else {
          AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
          return;
        }
      })
    }
  }

  updateReferrenceData() {
    const { type, selectedFile, previewImageSrc } = this.referralFile.state;
    if (type === 'library') {
      if (selectedFile) {
        const data = {
          referralFileId: selectedFile._id,
          referralImgUrl: selectedFile.url,
        };
        this.updateUserInfo(data, true);
      } else {
        AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
        return;
      }
    } else {
      this.setState({
        isValidating: true
      }, () => {
        if (previewImageSrc) {
          this.referralFile.submitNewFile().then((file) => {
            const data = {
              referralFileId: file._id,
              referralImgUrl: file.url,
            };
            this.updateUserInfo(data, true);
          })
        } else {
          AlertJsMessage(MESSAGES.SELECT_VIDEO_OR_IMAGE);
          return;
        }
      })
    }
  }

  updateUserInfo(data, isUpdateRef) {
    const { update } = this.props;
    this.props.updateUser(data).then((data) => {
      if(isUpdateRef) {
        update({
          referralContent: this.state.brand.referralContent
        }).then((response) => {
          window.location.reload();
        })
      } else {
        window.location.reload();
      }
    })
  }

  submitProductLink() {

    if (this.state.equipment.purchaseUrl) {
      if (URL_PATTERN.test(this.state.equipment.purchaseUrl)) {
        const data = {
          name: this.state.equipment.name,
          brandId: this.props.brand._id,
          purchaseUrl: this.state.equipment.purchaseUrl,
          assignUpdate: 'productLink'
        }
        this.submitForm(data, true);
      } else {
        AlertJsMessage('Shopping link must start with http:// or https:// .');
      }
    } else {
      AlertJsMessage('Please enter shopping link.');
    }
  }

  submitForm(formData, isProduct = false) {
    const { update, createEquipment, updateEquipment } = this.props;
    if (formData) {
      if (isProduct) {
        if (!this.state.equipment._id) {
          if (!formData.name) {
            AlertJsMessage('Please enter equipment name.');
            return;
          }
          createEquipment(formData).then((response) => {
            window.location.reload();
          })
        } else {
          updateEquipment(formData, this.state.equipment._id).then((response) => {
            window.location.reload();
          })
        }
      } else {
        update(formData).then((response) => {
          window.location.reload();
        })
      }
    }
  }

  submitActionPlanTab = () => {
    const { isActionPlanTab } = this.state.brand;
    this.submitForm({
      isActionPlanTab:isActionPlanTab
    });
  }

  handleActionPlanTab = field => event => {
		this.setState({
			brand: {
        ...this.state.brand,
        [field]: !event.target.checked,
      }
		});
	};

  render() {

    const { equipment, classes } = this.props;
    const { brand } = this.state;
    let fileId, profileFileId, logoFileId, equipmentFileId, referralFileId, referralContent;
    if (brand) {
      fileId = brand.fileId;
      profileFileId = brand.profileFileId;
      logoFileId = brand.logoFileId;
      referralContent = brand.referralContent;
    }
    if (equipment) {
      equipmentFileId = equipment.fileId;
    }
    if (this.props.currentUser) {
      const user = this.props.currentUser.user;
      referralFileId = user.referralFileId;
    }

    
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          currentUser={this.props.currentUser}
          activeRoute="/settings/edit-profile" />
        <h3>Main Page</h3>
        <p>You must save all pictures and text in every section after new data is inputted or uploaded.  Data will not save automatically.
          Please save all changes in each section.</p>
        <br />
        <div>
          <div>
            <FileSelection
              userData={this.props.user}
              type="upload"
              fileType="image"
              category="profile"
              imageCategory="mainPage"
              selectedFileId={fileId ? fileId : 0}
              ref={(ref) => { this.mainFile = ref ? ref.getWrappedInstance() : null }}
            />
            <TextField
              style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
              label="Display Name"
              value={this.state.brand.displayName}
              onChange={this.handleChange('displayName')}
              margin="dense"
              variant="outlined"
            />
          </div>
          <Button
            onClick={() => { this.submitMainData() }}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save Main Page Profile"
              icon="chevron-right" />
          </Button>

        </div>
        <hr />
        <div>
        <h3>Profile Page</h3>
        <div>
          <div>
            <div style={{ width: '100%' }}>
              <div style={{ width: '100%' }}>
                <h4>Upload Profile Photo</h4>
                <FileSelection
                  userData={this.props.user}
                  fileType="image"
                  category="profile"
                  imageCategory="profile"
                  selectedFileId={profileFileId ? profileFileId : 0}
                  ref={(ref) => { this.profileFile = ref ? ref.getWrappedInstance() : null }}
                />
                <Button
                  onClick={this.submitProfileCoverData}
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 10 }}
                >
                  <ButtonContent
                    text="Save"
                    icon="chevron-right" />
                </Button>
              </div>
              <hr />
              <div style={{ width: '100%' }}>
                <h4>Faceshot</h4>
                <FileSelection
                  userData={this.props.user}
                  fileType="image"
                  category="logo"
                  isDeleteAsset = {true}
                  deleteAssetAction = {() => {
                    this.setState({
                      brand: {
                        ...this.state.brand,
                        logoFileId: 0
                      }
                    })
                    this.logoFile.resetState();
                  }}
                  imageCategory="logo"
                  selectedFileId={ logoFileId ? logoFileId : 0}
                  ref={(ref) => { this.logoFile = ref ? ref.getWrappedInstance() : null }}
                />

               
                <Button
                  onClick={this.submitLogoData}
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 10 }}
                >
                  <ButtonContent
                    text="Save"
                    icon="chevron-right" />
                </Button>
              </div>
            </div>
            <div >
              <div style={{ width: '100%' }}><h4>About You</h4></div>
              <div style={{ display: 'inline-flex', width: '100%', justifyContent: 'space-between' }}>
                <div style={{ width: '45%' }} >
                <TextField
                    style={{ maxWidth: 820, marginTop: 10, marginBottom: 10, marginRight: 10 }}
                    label="A Brief Intro"
                    value={this.state.brand.story}
                    onChange={this.handleChange('story')}
                    multiline
                    rows={5}
                    id="outlined-multiline-static"
                    variant="outlined"
                    className={classes.root}
										InputProps={{
											className: classes.textarea,
											maxLength: 500
										}}
                  />
                </div>
                
              </div>
            </div>
          </div>
          <Button
            onClick={() => { this.submitProfileData() }}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save"
              icon="chevron-right" />
          </Button>

        </div>
        <h3>Timezone Preferences</h3>
        <div>
          <div>
              
          <TextField
                    style={{ maxWidth: 300, marginTop: 10 }}
                    label="Timezone"
                    value={this.state.timeZoneId || 0}
                    name="timeZoneId"
                    margin="dense"
                    variant="outlined"
                    select
                    onChange={this.handleTimeZoneChange('timeZoneId')}
                >
                {tzStrings && tzStrings.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>

          </div>
          <Button
            onClick={() => this.submitTimeZoneData()}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save"
              icon="chevron-right" />
          </Button>

        </div>
        <hr />
        <h4>Hide Action Client Tab</h4>
        <FormControlLabel
            control={
              <Checkbox
                onChange={this.handleActionPlanTab('isActionPlanTab')}
                checked = {!this.state.brand.isActionPlanTab}
                inputProps={{
                  'name': 'isActionPlanTab',
                }}
              />
            }
            name = "isActionPlanTab"
            label="Hide Action Plan button from Client."
            />
      </div>
      <Button
            onClick={() => { this.submitActionPlanTab() }}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save"
              icon="chevron-right" />
          </Button>
        <hr/>
        <h3>Product Picture</h3>
        <div>
          <div>
            <h4>Upload Product Picture Photo</h4>
            <FileSelection
              userData={this.props.user}
              fileType="image"
              category="profile"
              type="upload"
              imageCategory="product"
              selectedFileId={ equipmentFileId ? equipmentFileId : 0 }
              ref={(ref) => { this.productFile = ref ? ref.getWrappedInstance() : null }}
            />
            <div style={{width: '100%'}}>
            <TextField
              style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
              label="Product Name"
              value={this.state.equipment.name || ''}
              onChange={this.handleChange('name', 'equipment')}
              margin="dense"
              variant="outlined"
            />
            </div>
          </div>
          <Button
            onClick={() => { this.submitProductData() }}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save Product Picture Profile"
              icon="chevron-right" />
          </Button>
        </div>
        <hr />
        <div>
          <div>
            <TextField
              style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
              label="Shopping Link"
              value={this.state.equipment.purchaseUrl || ''}
              onChange={this.handleChange('purchaseUrl', 'equipment')}
              margin="dense"
              variant="outlined"
            />
          </div>
          <Button
            onClick={() => { this.submitProductLink() }}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save Link"
              icon="chevron-right" />
          </Button>
        </div>
        <hr />
            <h3>Web Referral Link Page</h3>
            <div>
              <div>
                <h4>Upload Photo</h4>
                <FileSelection
                  userData={this.props.user}
                  fileType="image"
                  category="profile"
                  isBrand={true}
                  selectedFileId={ referralFileId ? referralFileId : 0 }
                  ref={(ref) => { this.referralFile = ref ? ref.getWrappedInstance() : null }}
                />
              </div>

              <div style={{ display: 'inline-flex', width: '100%', justifyContent: 'space-between' }}>
                <div style={{ width: '45%' }} >
                <TextField
                    style={{ maxWidth: 820, marginTop: 10, marginBottom: 10, marginRight: 10 }}
                    label="Small Heading"
                    value={referralContent}
                    onChange={this.handleChange('referralContent')}
                    multiline
                    rows={5}
                    id="outlined-multiline-static"
                    variant="outlined"
                    className={classes.root}
										InputProps={{
											className: classes.textarea,
											maxLength: 200
										}}
                  />
                </div>
                
              </div>
              <div style={{ width: '45%', marginTop: '10px', marginBottom: '10px' }}>
                <Button
                  onClick={() => { this.updateReferrenceData() }}
                  variant="contained"
                  color="primary">
                  <ButtonContent
                    text="Save"
                    icon="chevron-right" />
                </Button>
              </div>
            </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    brand: state.brand.detail,
    equipment: state.brand.equipment
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetch: () => {
      return dispatch(fetch());
    },
    update: (data) => {
      return dispatch(update(data));

    },
    updateEquipment: (data, editId) => {
      return dispatch(updateEquipment(data, editId));

    },
    createEquipment: (data) => {
      return dispatch(createEquipment(data));
    },
    updateUser: (data) => {
      return dispatch(updateUser(data));
    },
    hideLoader: () => {
      return dispatch(hideLoader());
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(withStyles(styles)(BrandProfile));



// WEBPACK FOOTER //
// ./src/components/settings/BrandProfile.js